import React, { useState, useEffect } from "react";
export default function NonGst() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  
  const [form, setForm] = useState({ type: "Income", date: new Date().toISOString().split('T')[0], employee: "", particulars: "", amount: "" });
  
  const [fStart, setFStart] = useState("");
  const [fEnd, setFEnd] = useState("");
  const [fEmp, setFEmp] = useState("");
  const [fSearch, setFSearch] = useState("");

  const loadData = () => {
    setLoading(true);
    fetch('/api/transactions').then(r=>r.json()).then(d=>{
      setData(Array.isArray(d)?d:[]);
      setLoading(false);
    });
  };
  useEffect(() => { loadData(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = editId ? `/api/transactions/${editId}` : '/api/transactions';
    const method = editId ? 'PUT' : 'POST';
    await fetch(url, { method, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({...form, amount: Number(form.amount), type: "Income"}) });
    setShowForm(false); setEditId(null);
    setForm({ type: "Income", date: new Date().toISOString().split('T')[0], employee: "", particulars: "", amount: "" });
    loadData();
  };

  const handleEdit = (t) => { setForm(t); setEditId(t.id); setShowForm(true); };
  const handleDelete = async (id) => { if(window.confirm("Delete this record?")) { await fetch(`/api/transactions/${id}`, { method: 'DELETE' }); loadData(); } };

  const displayedData = data.filter(t => {
     if(t.type !== 'Income') return false;
     if(fStart && t.date < fStart) return false;
     if(fEnd && t.date > fEnd) return false;
     if(fEmp && t.employee !== fEmp) return false;
     if(fSearch && !(t.particulars || "").toLowerCase().includes(fSearch.toLowerCase())) return false;
     return true;
  });

  const totalFilteredIncome = displayedData.reduce((sum, t)=>sum+Number(t.amount||0), 0);
  const clearFilters = () => { setFStart(""); setFEnd(""); setFEmp(""); setFSearch(""); };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-green-700">Non-GST Payment Received</h1>
        <button onClick={() => {setShowForm(true); setEditId(null);}} className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded shadow">+ Add Payment</button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-green-50 p-4 rounded-lg shadow mb-6 grid grid-cols-2 md:grid-cols-4 gap-4 items-end relative border-t-4 border-green-500">
          <button type="button" onClick={()=>setShowForm(false)} className="absolute top-2 right-4 text-red-500 font-bold hover:underline">✕ Close</button>
          
          <div className="mt-4"><label className="block text-sm font-bold mb-1">Date</label><input required type="date" className="w-full border-2 p-2 rounded font-bold cursor-pointer" value={form.date} onChange={e=>setForm({...form, date: e.target.value})} /></div>
          <div className="mt-4"><label className="block text-sm font-bold mb-1">Received By (Employee)</label>
            <select required className="w-full border-2 p-2 rounded font-bold" value={form.employee} onChange={e=>setForm({...form, employee: e.target.value})}>
              <option value="">- Select Employee -</option>
              <option value="Shubham Agarwal">Shubham Agarwal</option>
              <option value="Rajendra Choudhary">Rajendra Choudhary</option><option value="DST">DST</option>
            </select>
          </div>
          <div className="mt-4"><label className="block text-sm font-bold mb-1">Particulars / Client Name</label><input required className="w-full border-2 p-2 rounded font-bold" placeholder="E.g. Cash from Client..." value={form.particulars} onChange={e=>setForm({...form, particulars: e.target.value})} /></div>
          <div className="mt-4"><label className="block text-sm font-bold mb-1">Amount (₹)</label><input required type="number" className="w-full border-2 p-2 rounded font-bold" value={form.amount} onChange={e=>setForm({...form, amount: e.target.value})} /></div>
          <button type="submit" className="bg-green-600 text-white px-6 py-3 rounded font-bold col-span-2 md:col-span-4 text-lg">{editId ? "Update Payment" : "Save Payment"}</button>
        </form>
      )}

      <div className="bg-white p-4 rounded-lg shadow mb-4 flex flex-wrap gap-4 items-end">
         <div className="font-bold text-gray-700 w-full md:w-auto mb-2 md:mb-0">Search Records:</div>
         <div><label className="text-xs font-bold text-gray-500">From Date</label><input type="date" className="border-2 p-2 rounded w-full font-bold text-gray-700" value={fStart} onChange={e=>setFStart(e.target.value)} /></div>
         <div><label className="text-xs font-bold text-gray-500">To Date</label><input type="date" className="border-2 p-2 rounded w-full font-bold text-gray-700" value={fEnd} onChange={e=>setFEnd(e.target.value)} /></div>
         <div>
            <label className="text-xs font-bold text-gray-500">Employee Filter</label>
            <select className="border-2 p-2 rounded w-full font-bold text-gray-700" value={fEmp} onChange={e=>setFEmp(e.target.value)}>
                <option value="">All Employees</option>
                <option value="Shubham Agarwal">Shubham Agarwal</option>
                <option value="Rajendra Choudhary">Rajendra Choudhary</option><option value="DST">DST</option>
            </select>
         </div>
         <div>
            <label className="text-xs font-bold text-gray-500">Search by Name/Details</label>
            <input type="text" placeholder="Type name here..." className="border-2 border-blue-400 p-2 rounded w-full font-bold" value={fSearch} onChange={e=>setFSearch(e.target.value)} />
         </div>
         <div>
            <button onClick={clearFilters} className="bg-gray-200 text-gray-800 font-bold px-4 py-2 rounded hover:bg-gray-300">Clear Filters</button>
         </div>
         <div className="ml-auto text-right mt-4 md:mt-0 bg-green-50 p-2 rounded border border-green-200">
             <div className="text-sm font-bold text-gray-600">Filtered Total Amount</div>
             <div className="text-2xl font-bold text-green-700">₹{totalFilteredIncome.toFixed(2)}</div>
         </div>
      </div>

      <div className="bg-white shadow rounded-lg p-4 overflow-x-auto">
        <table className="min-w-full text-left">
          <thead><tr className="border-b-2 text-gray-500 uppercase text-sm"><th className="pb-2 p-2">Date</th><th className="pb-2 p-2">Employee</th><th className="pb-2 p-2">Particulars/Client</th><th className="pb-2 p-2 text-right">Amount</th><th className="pb-2 p-2 text-center">Actions</th></tr></thead>
          <tbody>
            {loading ? <tr><td colSpan="5" className="text-center p-4 text-blue-500 font-bold">Loading Data... Please wait</td></tr> :
             displayedData.length===0 ? <tr><td colSpan="5" className="text-center p-4 text-gray-500">No records found.</td></tr> :
             displayedData.map((t,i) => (
              <tr key={i} className="border-b hover:bg-green-50">
                  <td className="p-2 text-gray-600 font-medium">{t.date}</td>
                  <td className="p-2 font-bold text-green-800">{t.employee}</td>
                  <td className="p-2 font-semibold text-gray-800">{t.particulars}</td>
                  <td className="p-2 text-right font-bold text-gray-900 text-lg">₹{Number(t.amount || 0).toFixed(2)}</td>
                  <td className="p-2 text-center">
                    <button onClick={()=>handleEdit(t)} className="bg-blue-100 text-blue-700 px-3 py-1 rounded text-xs font-bold mr-2 hover:bg-blue-200">Edit</button>
                    <button onClick={()=>handleDelete(t.id)} className="bg-red-100 text-red-700 px-3 py-1 rounded text-xs font-bold hover:bg-red-200">Del</button>
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
